import {
  faBug,
  faFile,
  faInfoCircle,
  faList,
  faQuestionCircle,
  faQuoteLeft,
} from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';
import { generatePath } from 'react-router';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import {
  NavItem,
  Separator,
} from '#src/components/navigation/NavItem/index.tsx';
import {
  BLOG_SPORT,
  GAME_RULES,
  HELP,
  LEGAL_NOTICE,
  TERMS_AND_CONDITIONS,
} from '#src/constants/__generated__/routes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import { navLabels } from '#src/lib/glossary.ts';
import { sportToBlogSportMap } from '#src/lib/routing.tsx';

import { Footer } from './Footer/index.tsx';

const Root = styled(Vertical).attrs({ gap: 0.5 })`
  border-radius: var(--intermediate-unit);
  background-color: var(--c-black);
`;
const SeparatorWrapper = styled(Horizontal)`
  width: 100%;
  padding: var(--unit) var(--unit) var(--half-unit) var(--unit);
`;

type Props = { onClick?: () => void; noFooter?: boolean };
export const MoreNavItems = ({ onClick, noFooter }: Props) => {
  const { formatMessage } = useIntl();
  const { isAndroidApp, postMessage } = useIsMobileApp();
  const {
    flags: { isSorareInternal = false },
  } = useFeatureFlags();
  const { sport: currentSport } = useSportContext();

  return (
    <Root onClick={onClick}>
      {!!isAndroidApp && !!isSorareInternal && (
        <NavItem
          icon={() => <FontAwesomeIcon icon={faBug} />}
          label={formatMessage(navLabels.mobileDebugScreen)}
          onClick={() => {
            postMessage('debugScreen', {});
          }}
        />
      )}
      <NavItem
        icon={() => <FontAwesomeIcon icon={faQuoteLeft} />}
        label={formatMessage(navLabels.blog)}
        to={generatePath(BLOG_SPORT, {
          sport: sportToBlogSportMap[currentSport],
        })}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faQuestionCircle} />}
        label={formatMessage(navLabels.help)}
        to={HELP}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faInfoCircle} />}
        label={formatMessage(navLabels.gameRules)}
        to={GAME_RULES}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faList} />}
        label={formatMessage(navLabels.terms)}
        to={TERMS_AND_CONDITIONS}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={faFile} />}
        label={formatMessage(navLabels.legalNotice)}
        to={LEGAL_NOTICE}
      />
      {!noFooter && (
        <>
          <SeparatorWrapper>
            <Separator />
          </SeparatorWrapper>
          <Footer copyrightWrapped />
        </>
      )}
    </Root>
  );
};
